module.exports = __webpack_public_path__ + "static/jamesmathew-733d6e03a01c75a2ac9e14c618210319.jpeg";